import { Component, Input, OnInit, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { mapLayer } from 'src/app/interfaces/common';
import { LayerService } from 'src/app/services/layer.service';
interface ScalarLegendEntry {
  color: string;
  label: string;
}

interface ActiveScalarLegend {
  title: string;
  entries: ScalarLegendEntry[];
}

@Component({
  selector: 'app-scalar-legend',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './scalar-legend.component.html',
  styleUrl: './scalar-legend.component.css',
})
export class ScalarLegendComponent implements OnInit {
  @Input() mapLayers: mapLayer[] = [];

  visibleLegends: ActiveScalarLegend[] = [];

  private destroyRef = inject(DestroyRef);

  constructor(private layerService: LayerService) {}

  ngOnInit(): void {
    this.layerService
      .getNewMaplayersStatus()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.computeVisibleLegends());
  }

  private computeVisibleLegends(): void {
    this.visibleLegends = this.mapLayers
      .filter(ml => ml.checked && ml.option?.scalarLegend)
      .map(ml => ml.option.scalarLegend as ActiveScalarLegend);
  }
}
